import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from '../../commons/http-uilis.service';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { keycloakLogout } from '../../../auth/keycloak.config';
import { LicenseList, LicenseListDataArray } from '../../../model/license/license-list';


@Injectable({
    providedIn: 'root'
})
export class LicenseService {
    private _url: string = `${environment.baseAPIURL}/settings`;
    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

    GETPaginatedLicenses(paging:Paging): Observable<LicenseList>  | any{
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/licenses${this.buildQueryString(paging)}`,{ headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: LicenseListDataArray = jsonConvert.deserializeObject(res, LicenseListDataArray);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) {
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTLicenseStatus(licenseId:string, body:LicenseList){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/licenses/${licenseId}`, this.toUpdatePayload(body), { headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETELicense(licenseId:string){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/licenses/${licenseId}`, { headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    private buildQueryString(paging: Paging): string {
        const params = new URLSearchParams({
            offset: String((paging.pageIndex - 1) * paging.pageSize),
            limit: String(paging.pageSize)
        });
        return `?${params.toString()}`;
    }

    private toUpdatePayload(body: LicenseList) {
        return {
            duration: body.duration,
            enabled: body.enabled
        };
    }
} 
